/**
 * useLoadingMessages Hook
 * Cycles through loading messages with interval
 * Extracted from App.js to eliminate duplication
 */

import { useState, useEffect } from 'react';

/**
 * Loading message cycling hook
 *
 * @param {Array<string>} messages - Array of messages to cycle through
 * @param {boolean} isLoading - Whether loading is active
 * @param {number} interval - Cycle interval in milliseconds (default: 3000)
 * @returns {string} Current message
 */
const useLoadingMessages = (messages, isLoading, interval = 3000) => {
    const [currentMessage, setCurrentMessage] = useState(messages[0] || '');

    useEffect(() => {
        if (!isLoading || messages.length === 0) {
            setCurrentMessage(messages[0] || '');
            return;
        }

        let index = 0;
        setCurrentMessage(messages[0]);

        const timer = setInterval(() => {
            index = (index + 1) % messages.length;
            setCurrentMessage(messages[index]);
        }, interval);

        return () => clearInterval(timer);
    }, [isLoading, messages, interval]);

    return currentMessage;
};

export default useLoadingMessages;
